import styled from 'styled-components'

const TitlePage = styled('h1')`
  color: var(--main-blue);
  font-size: 1.7em;
  @media screen and (max-width:700px){
    display: none;
  }
`
export default TitlePage
